type SectionTitleProps = {
  title: string
  className?: string
}
export default function SectionTitle({ title, className }: SectionTitleProps): JSX.Element {
  return (
    <h1 className={`font-bold text-2xl sm:text-[40px] sm:leading-[56px] text-[var(--text-title)] ${className ?? ''}`}>
      {title}
    </h1>
  )
}
